import React from 'react';
import { Search, Coffee, Users } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';

//Alexis
import { setVentaData } from '../utils/ventaTemp';


export function POSPage({
  products,
  categories,
  selectedCategory,
  searchTerm,
  currentOrder,
  activeOrders,
  setSelectedCategory,
  setSearchTerm,
   buscarProductosDesdeBack, // 👈 AGREGAR AQUÍ
  addProductToOrder,
  selectOrder,
  processPayment,
  calculateOrderTotal,
  filteredProducts,
}) {
  const tables = activeOrders.filter(order => order.type === 'table');
  const customers = activeOrders.filter(order => order.type === 'customer');

  

//console.log('🧪 Productos filtrados:', filteredProducts);

  return (
    <div className="space-y-4">
      {/* Quick Select Panel */}
      <div className="bg-white p-4 rounded-lg shadow-sm">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Mesas */}
          <div>
            <h3 className="font-medium mb-3 flex items-center gap-2">
              <Coffee className="h-4 w-4" />
              Mesas Activas
            </h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
              {tables.map(table => (
                <Button
                  key={table.id}
                  variant={currentOrder?.id === table.id ? "default" : "outline"}
                  className="h-16 flex flex-col items-center justify-center p-2"
                  onClick={() => selectOrder(table)}
                >
                  <span className="font-medium text-sm">{table.name}</span>
                  <span className="text-xs">
                    ${calculateOrderTotal(table).toFixed(2)}
                  </span>
                </Button>
              ))}
              {tables.length === 0 && (
                <p className="col-span-full text-sm text-gray-500 text-center py-2">
                  No hay mesas activas
                </p>
              )}
            </div>
          </div>

          {/* Clientes */}
          <div>
            <h3 className="font-medium mb-3 flex items-center gap-2">
              <Users className="h-4 w-4" />
              Clientes Activos
            </h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
              {customers.map(customer => (
                <Button
                  key={customer.id}
                  variant={currentOrder?.id === customer.id ? "default" : "outline"}
                  className="h-16 flex flex-col items-center justify-center p-2"
                  onClick={() => selectOrder(customer)}
                >
                  <span className="font-medium text-sm">{customer.name}</span>
                  <span className="text-xs">
                    ${calculateOrderTotal(customer).toFixed(2)}
                  </span>
                </Button>
              ))}
              {customers.length === 0 && (
                <p className="col-span-full text-sm text-gray-500 text-center py-2">
                  No hay clientes activos
                </p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Products Panel */}
      {currentOrder ? (
        <div className="bg-white p-4 rounded-lg shadow-sm">
          <div className="flex justify-between items-center mb-3">
            <div>
              <h3 className="font-medium">
                {currentOrder.type === 'table' ? 'Mesa' : 'Cliente'}: {currentOrder.name}
              </h3>
              <p className="text-sm text-gray-500">
                {currentOrder.items.length} productos en la orden
              </p>
            </div>
            <div className="flex gap-2 items-center">
              <select
                className="px-2 py-1 text-sm border rounded-md"
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
              >
                {categories.map(category => (
                  <option key={category} value={category}>{category}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="relative mb-3">
            <Search className="absolute left-2 top-2.5 h-4 w-4 text-gray-500" />
            <Input
              placeholder="Buscar productos..."
              className="pl-8"
              value={searchTerm}
              onChange={(e) => {
                const valor = e.target.value;
                setSearchTerm(valor);
                buscarProductosDesdeBack(valor);
              }}
            />

          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
            {filteredProducts.map((product, index) => (
              <Button
                key={product.id || `product-${index}`}
                variant="outline"
                className="h-20 flex flex-col items-center justify-center text-center p-2"
                onClick={() => addProductToOrder(product)}
              >
                <span className="font-medium text-sm">{product.name}</span>
                <span className="text-xs text-gray-500">
                  ${typeof product.price === 'number' ? product.price.toFixed(2) : '0.00'}
                </span>
              </Button>
            ))}
            
            {filteredProducts.length === 0 && (
              <div className="col-span-full text-center py-8 text-gray-500">
                No se encontraron productos
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="h-[calc(100vh-24rem)] flex items-center justify-center">
          <div className="text-center space-y-4">
            <div className="flex justify-center space-x-4">
              <div className="bg-blue-50 p-4 rounded-full">
                <Coffee className="h-8 w-8 text-blue-500" />
              </div>
              <div className="bg-blue-50 p-4 rounded-full">
                <Users className="h-8 w-8 text-blue-500" />
              </div>
            </div>
            <div>
              <h2 className="text-xl font-semibold text-gray-900">Selecciona una Mesa o Cliente</h2>
              <p className="mt-1 text-gray-500">
                Selecciona una mesa o cliente de la lista superior para comenzar
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}